// The fields a block can open with, in whichever order the block draws them —
// a Fast Fact puts its title ahead of its body text.
const EDITABLE_SELECTOR =
  '[data-assembly--lexical-target="editable"], editable-content, textarea[name="element[prompt]"]'

// The block's markup rides the assembly broadcast, which can land after the
// response asking for this focus, so the node is routinely absent on arrival.
const WAIT_MS = 5000

// Focusing the rich-text div is the whole of it: `assembly--lexical` listens
// for `focusin` across the canvas and builds the editor, the caret and the
// paste handling for whichever block it hears from. A plain field is asked
// instead, since it opens for editing on its own terms (`startEditing`).
export function focusElementStreamAction () {
  const id = this.getAttribute('target')
  if (!id) return

  withElement(id, (element) => {
    const editable = element.querySelector(EDITABLE_SELECTOR)
    if (!editable || isTyping(document.activeElement)) return

    if (typeof editable.startEditing === 'function') editable.startEditing()
    else editable.focus()
  })
}

function withElement (id, callback) {
  const present = document.getElementById(id)
  if (present) return callback(present)

  const observer = new MutationObserver(() => {
    const arrived = document.getElementById(id)
    if (!arrived) return

    stop()
    callback(arrived)
  })

  const deadline = setTimeout(stop, WAIT_MS)
  observer.observe(document.body, { childList: true, subtree: true })

  function stop () {
    clearTimeout(deadline)
    observer.disconnect()
  }
}

// The author may have started typing elsewhere while this waited, and pulling
// the caret out mid-sentence is worse than leaving the new block unfocused.
function isTyping (active) {
  if (!active || active === document.body) return false

  return active.isContentEditable || !!active.closest?.('input, textarea, select')
}
